"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKEvent = void 0;
var SDKEvent;
(function (SDKEvent) {
    SDKEvent["TransfersPaused"] = "transfersPaused";
    SDKEvent["TransfersResumed"] = "transfersResumed";
    SDKEvent["RequestsThrottled"] = "requestsThrottled";
    SDKEvent["RequestsUnthrottled"] = "requestsUnthrottled";
})(SDKEvent || (exports.SDKEvent = SDKEvent = {}));
//# sourceMappingURL=events.js.map